import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** DNA validator: writing phrase appears in runtime output from buildNormalizedDay + pilot utils. */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "לזהות את הקול",
    opening: localizedGenderNode(
      [
      "היום אני מבחין/ה בקול השיפוט.",
      "אני לא הקול הזה.",
      "אני כאן."
    ],
      [
      "היום אני מבחין/ה בקול השיפוט.",
      "אני לא הקול הזה.",
      "אני כאן."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מתי הקול הזה מופיע?",
      "אילו מילים הוא אומר?",
      "מה אני מרגיש/ה אחר כך?"
    ],
      [
      "מתי הקול הזה מופיע?",
      "אילו מילים הוא אומר?",
      "מה אני מרגיש/ה אחר כך?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "קול הוא קול, לא אני."
    ],
      [
      "קול הוא קול, לא אני."
    ]
    ),
    action: localizedGenderNode(
      "לכתוב משפט אחד - \"זה קול, לא אמת\".",
      "לכתוב משפט אחד - \"זה קול, לא אמת\"."
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "הרגע שמפעיל",
    opening: localizedGenderNode(
      [
      "היום אני שם/ה לב לרגע שבו השיפוט נדלק.",
      "רק לראות.",
      "אני נשאר/ת איתי."
    ],
      [
      "היום אני שם/ה לב לרגע שבו השיפוט נדלק.",
      "רק לראות.",
      "אני נשאר/ת איתי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת פנימה והחוצה.",
      "נשימה אחת."
    ],
      [
      "אני נושם/ת פנימה והחוצה.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה קרה ממש לפני שהקול התחיל?",
      "מה הקול אומר לי אז?",
      "איפה זה יושב בגוף?"
    ],
      [
      "מה קרה ממש לפני שהקול התחיל?",
      "מה הקול אומר לי אז?",
      "איפה זה יושב בגוף?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "ברגע הראשון יש מרווח קטן."
    ],
      [
      "ברגע הראשון יש מרווח קטן."
    ]
    ),
    action: localizedGenderNode(
      "נשימה אחת כשהקול עולה.",
      "נשימה אחת כשהקול עולה."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "הגוף תחת שיפוט",
    opening: localizedGenderNode(
      [
      "היום אני מקשיב/ה לגוף כשהשיפוט עולה.",
      "לא כדי לשנות.",
      "אני כאן."
    ],
      [
      "היום אני מקשיב/ה לגוף כשהשיפוט עולה.",
      "לא כדי לשנות.",
      "אני כאן."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני שם/ה לב לנשימה.",
      "נשימה אחת."
    ],
      [
      "אני שם/ה לב לנשימה.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איפה הגוף מחזיק את השיפוט?",
      "מה הגוף בוחר/ת ברגע הזה?",
      "מה יכול להתרכך מעט?"
    ],
      [
      "איפה הגוף מחזיק את השיפוט?",
      "מה הגוף בוחר/ת ברגע הזה?",
      "מה יכול להתרכך מעט?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "הגוף לא אשׁם, הוא רק מחזיק."
    ],
      [
      "הגוף לא אשׁם, הוא רק מחזיק."
    ]
    ),
    action: localizedGenderNode(
      "יד על החזה ונשימה אחת.",
      "יד על החזה ונשימה אחת."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "סיפור מול עובדה",
    opening: localizedGenderNode(
      [
      "היום אני מפריד/ה בין עובדה לסיפור.",
      "בלי להילחם.",
      "אני נשאר/ת איתי."
    ],
      [
      "היום אני מפריד/ה בין עובדה לסיפור.",
      "בלי להילחם.",
      "אני נשאר/ת איתי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת פנימה והחוצה.",
      "נשימה אחת."
    ],
      [
      "אני נושם/ת פנימה והחוצה.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה העובדה הפשוטה כאן?",
      "איזה סיפור קפץ מיד?",
      "איזו אפשרות עדינה יכולה גם להיות נכונה?"
    ],
      [
      "מה העובדה הפשוטה כאן?",
      "איזה סיפור קפץ מיד?",
      "איזו אפשרות עדינה יכולה גם להיות נכונה?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סיפור הוא לא אני."
    ],
      [
      "סיפור הוא לא אני."
    ]
    ),
    action: localizedGenderNode(
      "משפט פנימי - \"זו פרשנות\".",
      "משפט פנימי - \"זו פרשנות\"."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "מה הקול מנסה לעשות",
    opening: localizedGenderNode(
      [
      "היום אני בודק/ת מה הקול מנסה להשיג.",
      "בלי להצדיק.",
      "אני כאן."
    ],
      [
      "היום אני בודק/ת מה הקול מנסה להשיג.",
      "בלי להצדיק.",
      "אני כאן."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני מרכך/ת מעט את הכתפיים.",
      "נשימה אחת."
    ],
      [
      "אני מרכך/ת מעט את הכתפיים.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "ממה הקול מנסה להגן עליי?",
      "ממה הוא מפחד?",
      "מה המחיר שאני משלם/ת?"
    ],
      [
      "ממה הקול מנסה להגן עליי?",
      "ממה הוא מפחד?",
      "מה המחיר שאני משלם/ת?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "אם זה מנסה להגן, אני יכול/ה לראות גם את המחיר."
    ],
      [
      "אם זה מנסה להגן, אני יכול/ה לראות גם את המחיר."
    ]
    ),
    action: localizedGenderNode(
      "משפט אחד של הבנה.",
      "משפט אחד של הבנה."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "קול ישן",
    opening: localizedGenderNode(
      [
      "היום אני בודק/ת אם זה קול ישן.",
      "לא כדי לחפור.",
      "אני כאן."
    ],
      [
      "היום אני בודק/ת אם זה קול ישן.",
      "לא כדי לחפור.",
      "אני כאן."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני שם/ה לב לרגליים.",
      "נשימה אחת."
    ],
      [
      "אני שם/ה לב לרגליים.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "למי הקול הזה דומה לי?",
      "מתי שמעתי אותו בעבר?",
      "מה הייתי בוחר/ת/ה אז?"
    ],
      [
      "למי הקול הזה דומה לי?",
      "מתי שמעתי אותו בעבר?",
      "מה הייתי בוחר/ת/ה אז?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "אם זה קול ישן, אני יכול/ה להחזיק אותו בעדינות."
    ],
      [
      "אם זה קול ישן, אני יכול/ה להחזיק אותו בעדינות."
    ]
    ),
    action: localizedGenderNode(
      "לומר בלב \"זה קול ישן\" פעם אחת.",
      "לומר בלב \"זה קול ישן\" פעם אחת."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "המחיר",
    opening: localizedGenderNode(
      [
      "היום אני רואה את המחיר של השיפוט.",
      "בלי להעניש.",
      "אני נשאר/ת איתי."
    ],
      [
      "היום אני רואה את המחיר של השיפוט.",
      "בלי להעניש.",
      "אני נשאר/ת איתי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני מרגיש/ה את הישיבה שלי.",
      "נשימה אחת."
    ],
      [
      "אני מרגיש/ה את הישיבה שלי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה השיפוט הזה לוקח ממני?",
      "איזה חלק בי מצטמצם?",
      "מה הייתי רוצה להחזיר לעצמי?"
    ],
      [
      "מה השיפוט הזה לוקח ממני?",
      "איזה חלק בי מצטמצם?",
      "מה הייתי רוצה להחזיר לעצמי?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "לראות את המחיר הוא צעד של חמלה."
    ],
      [
      "לראות את המחיר הוא צעד של חמלה."
    ]
    ),
    action: localizedGenderNode(
      "לכתוב מילה אחת על מה שאני מחזיר/ה לעצמי.",
      "לכתוב מילה אחת על מה שאני מחזיר/ה לעצמי."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "חמלה קטנה",
    opening: localizedGenderNode(
      [
      "היום אני מנסה לדבר אליי ברוך.",
      "לא מושלם, רק מעט.",
      "אני כאן."
    ],
      [
      "היום אני מנסה לדבר אליי ברוך.",
      "לא מושלם, רק מעט.",
      "אני כאן."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני מרכך/ת את הלסת.",
      "נשימה אחת."
    ],
      [
      "אני מרכך/ת את הלסת.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איך הייתי מדבר/ת לחבר/ה כאן?",
      "איזה משפט רך אני בוחר/ת/ה לשמוע?",
      "מה משתנה בי כשאני שומע/ת אותו?"
    ],
      [
      "איך הייתי מדבר/ת לחבר/ה כאן?",
      "איזה משפט רך אני בוחר/ת/ה לשמוע?",
      "מה משתנה בי כשאני שומע/ת אותו?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "מילה רכה אחת יכולה לשנות את הטון."
    ],
      [
      "מילה רכה אחת יכולה לשנות את הטון."
    ]
    ),
    action: localizedGenderNode(
      "משפט רך אחד לעצמי.",
      "משפט רך אחד לעצמי."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "גבול פנימי",
    opening: localizedGenderNode(
      [
      "היום אני מציב/ה גבול לקול האכזרי.",
      "בשקט.",
      "אני כאן."
    ],
      [
      "היום אני מציב/ה גבול לקול האכזרי.",
      "בשקט.",
      "אני כאן."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני מרגיש/ה את הגב נתמך.",
      "נשימה אחת."
    ],
      [
      "אני מרגיש/ה את הגב נתמך.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איזה משפטים הם יותר מדי בשבילי?",
      "מה הגבול שאני רוצה להציב?",
      "איך אני אומר/ת אותו לעצמי?"
    ],
      [
      "איזה משפטים הם יותר מדי בשבילי?",
      "מה הגבול שאני רוצה להציב?",
      "איך אני אומר/ת אותו לעצמי?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "גבול פנימי הוא הגנה, לא מלחמה."
    ],
      [
      "גבול פנימי הוא הגנה, לא מלחמה."
    ]
    ),
    action: localizedGenderNode(
      "לומר \"אני לא מדבר/ת כך אליי\".",
      "לומר \"אני לא מדבר/ת כך אליי\"."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "בקשה לעצמי",
    opening: localizedGenderNode(
      [
      "היום אני נותן/ת לעצמי בקשה אחת ברורה.",
      "בלי להעניש.",
      "אני נשאר/ת איתי."
    ],
      [
      "היום אני נותן/ת לעצמי בקשה אחת ברורה.",
      "בלי להעניש.",
      "אני נשאר/ת איתי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת לאט.",
      "נשימה אחת."
    ],
      [
      "אני נושם/ת לאט.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה הבקשה הכי חשובה לי עכשיו?",
      "איך אני אומר/ת אותה במשפט אחד?",
      "מה אני מוכן/ה לתת לעצמי בתמורה?"
    ],
      [
      "מה הבקשה הכי חשובה לי עכשיו?",
      "איך אני אומר/ת אותה במשפט אחד?",
      "מה אני מוכן/ה לתת לעצמי בתמורה?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "בקשה אחת יכולה לרכך את היום."
    ],
      [
      "בקשה אחת יכולה לרכך את היום."
    ]
    ),
    action: localizedGenderNode(
      "לכתוב את הבקשה במשפט קצר.",
      "לכתוב את הבקשה במשפט קצר."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "משפט חדש",
    opening: localizedGenderNode(
      [
      "היום אני בוחר/ת משפט חדש לעצמי.",
      "קטן ופשוט.",
      "אני כאן."
    ],
      [
      "היום אני בוחר/ת משפט חדש לעצמי.",
      "קטן ופשוט.",
      "אני כאן."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני שם/ה לב לקול הפנימי.",
      "נשימה אחת."
    ],
      [
      "אני שם/ה לב לקול הפנימי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איזה משפט חדש אני רוצה לומר לעצמי?",
      "מתי הכי הייתי בוחר/ת/ה לשמוע אותו?",
      "איך זה מרגיש כשאני אומר/ת אותו?"
    ],
      [
      "איזה משפט חדש אני רוצה לומר לעצמי?",
      "מתי הכי הייתי בוחר/ת/ה לשמוע אותו?",
      "איך זה מרגיש כשאני אומר/ת אותו?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "משפט חדש יוצר מרווח קטן."
    ],
      [
      "משפט חדש יוצר מרווח קטן."
    ]
    ),
    action: localizedGenderNode(
      "להגיד את המשפט פעם אחת.",
      "להגיד את המשפט פעם אחת."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "תיקון אחרי נפילה",
    opening: localizedGenderNode(
      [
      "היום אני לומד/ת לחזור לעצמי אחרי נפילה.",
      "בלי עונש.",
      "אני כאן."
    ],
      [
      "היום אני לומד/ת לחזור לעצמי אחרי נפילה.",
      "בלי עונש.",
      "אני כאן."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מתי הקול חוזר אחרי טעות?",
      "מה עוזר לי לחזור לעצמי?",
      "איזה משפט תיקון אני רוצה לומר?"
    ],
      [
      "מתי הקול חוזר אחרי טעות?",
      "מה עוזר לי לחזור לעצמי?",
      "איזה משפט תיקון אני רוצה לומר?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "תיקון הוא חזרה עדינה, לא ביטול."
    ],
      [
      "תיקון הוא חזרה עדינה, לא ביטול."
    ]
    ),
    action: localizedGenderNode(
      "משפט תיקון אחד קצר.",
      "משפט תיקון אחד קצר."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "תרגול קטן",
    opening: localizedGenderNode(
      [
      "היום אני בוחר/ת תרגול קטן וקבוע.",
      "לא גדול.",
      "אני כאן."
    ],
      [
      "היום אני בוחר/ת תרגול קטן וקבוע.",
      "לא גדול.",
      "אני כאן."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני מרגיש/ה את הישיבה שלי.",
      "נשימה אחת."
    ],
      [
      "אני מרגיש/ה את הישיבה שלי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה תרגול קטן יעזור לי להתמיד?",
      "מתי ביום אני יכול/ה לעשות אותו?",
      "מה יזכיר לי בעדינות?"
    ],
      [
      "מה תרגול קטן יעזור לי להתמיד?",
      "מתי ביום אני יכול/ה לעשות אותו?",
      "מה יזכיר לי בעדינות?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "תרגול קטן בונה קול חדש."
    ],
      [
      "תרגול קטן בונה קול חדש."
    ]
    ),
    action: localizedGenderNode(
      "לבחור רגע אחד לתרגול.",
      "לבחור רגע אחד לתרגול."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "סגירה רכה",
    opening: localizedGenderNode(
      [
      "היום אני מסיים/ת את המסע ברוך.",
      "בלי לכפות סיום מושלם.",
      "אני כאן."
    ],
      [
      "היום אני מסיים/ת את המסע ברוך.",
      "בלי לכפות סיום מושלם.",
      "אני כאן."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה למדתי על הקול הזה?",
      "מה הסימן המוקדם שהוא חוזר?",
      "משפט חזרה לרגע לפני - מה אני אומר/ת לעצמי?"
    ],
      [
      "מה למדתי על הקול הזה?",
      "מה הסימן המוקדם שהוא חוזר?",
      "משפט חזרה לרגע לפני - מה אני אומר/ת לעצמי?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "אני יכול/ה להיות מדויק/ת בלי אכזריות."
    ],
      [
      "אני יכול/ה להיות מדויק/ת בלי אכזריות."
    ]
    ),
    action: localizedGenderNode(
      "נשימה אחת לפני תגובה.",
      "נשימה אחת לפני תגובה."
    ),
  },
].map(buildNormalizedDay);

export const cruelSelfJudgmentBlueprintHe = buildNormalizedPilotBlueprint({
  id: "cruel_self_judgment_14d",
  version: "tri_locale_emit_he_v1",
  durationDays: 14,
  problemKey: "cruel_self_judgment",
  category: "self_worth",
  journeyName: {
    he: "שיפוט עצמי אכזרי (איך שוב עשיתי את זה)",
    en: "Cruel self-judgment (How did I do it again)",
    es: "Juicio propio cruel (¿Cómo lo hice otra vez?)",
  },
  days,
});

export default cruelSelfJudgmentBlueprintHe;
